import Seo from '../components/common/Seo';
import { SITE_NAME, SITE_URL, CONTACT_EMAIL, LEGAL_UPDATED } from '../constants/site';

// TODO: have this reviewed before launch — it is a starting template, not legal advice.
function PrivacyPolicy() {
  return (
    <div className="container page prose">
      <Seo
        title="Privacy Policy"
        path="/privacy-policy"
        description={`How ${SITE_NAME} collects, uses and protects your information.`}
      />

      <h1 className="page-title">Privacy Policy</h1>
      <p className="page-sub">
        Last updated: <time dateTime={LEGAL_UPDATED}>{LEGAL_UPDATED}</time>
      </p>

      <h2>Who we are</h2>
      <p>
        {SITE_NAME} ({SITE_URL}) publishes articles and guides. This policy explains what
        information we collect when you visit the site and how it is used.
      </p>

      <h2>Information we collect</h2>
      <ul>
        <li>
          <strong>Usage data.</strong> Pages visited, referrer, approximate location, browser and
          device type — collected in aggregate to understand what content is useful.
        </li>
        <li>
          <strong>Local storage.</strong> We store small values in your browser (for example an
          admin session token, only if you are an administrator who has logged in). These never
          leave your device except when authenticating with our identity provider.
        </li>
        <li>
          <strong>We do not</strong> ask readers to create accounts, and we do not collect payment
          information.
        </li>
      </ul>

      <h2>Cookies and analytics</h2>
      <p>
        We may use privacy-respecting analytics to measure traffic. Third-party embeds (such as
        images or videos hosted elsewhere) may set their own cookies; their policies apply to them.
      </p>

      <h2>How we use information</h2>
      <ul>
        <li>To operate, maintain and improve the site and its content.</li>
        <li>To detect and prevent abuse.</li>
        <li>To comply with legal obligations.</li>
      </ul>

      <h2>Sharing</h2>
      <p>
        We do not sell personal information. We share data only with service providers who help us
        run the site (hosting, authentication, analytics) and only as needed for that purpose.
      </p>

      <h2>Data retention</h2>
      <p>
        Aggregate usage data is retained only as long as it is useful for the purposes above.
        Admin session tokens expire automatically.
      </p>

      <h2>Your choices</h2>
      <p>
        You can block cookies and clear local storage in your browser settings at any time. To
        request information about data we hold, contact us.
      </p>

      <h2>Children</h2>
      <p>The site is not directed at children under 13 and we do not knowingly collect their data.</p>

      <h2>Changes</h2>
      <p>
        We may update this policy. Material changes will be reflected in the “Last updated” date
        above.
      </p>

      <h2>Contact</h2>
      <p>
        <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
      </p>
    </div>
  );
}

export default PrivacyPolicy;
